import { useAccessToken } from '@app/auth';
import { useCallback, useRef, useEffect } from 'react';

/**
 * Wrapper around useAccessToken that returns a stable function reference.
 * This prevents infinite loops in useEffect hooks that depend on the token getter.
 * 
 * Use this instead of useAccessToken() in GranularDeploy components/hooks.
 */
export function useStableAccessToken() {
  const tokenGetter = useAccessToken();
  const tokenGetterRef = useRef(tokenGetter);

  // Keep the ref updated with the latest tokenGetter function
  useEffect(() => {
    tokenGetterRef.current = tokenGetter;
  }, [tokenGetter]);

  // Return a stable function that always uses the latest tokenGetter
  const stableTokenGetter = useCallback(async () => {
    return await tokenGetterRef.current();
  }, []); // Empty deps - function is stable, uses ref for latest tokenGetter

  return stableTokenGetter;
}

